import { type GivingContentObjectList, GivingTypeEnum } from 'models';
import { useTranslation } from 'react-i18next';
import { routes } from 'routes/routes';
import { Card, Col, DataCardParticipants, Icon, Image, Link, Row, Tag, Text } from 'ui';
import { images } from 'common/utils';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { useGivingTypeOptions } from 'features/givings/hooks';

type P = {
  item: GivingContentObjectList;
};

const GivingContentObjectBody = ({ item }: P) => {
  const { t } = useTranslation();
  const { getTranslate } = useGivingTypeOptions();
  const { giving } = item;
  const isParticipantsVisible = giving.type === GivingTypeEnum.CROWDFUNDING || giving.type === GivingTypeEnum.DONATION;

  return (
    <Row gutter={[0, 'sm']}>
      <Col span={24}>
        <Link to={routes.giving.detail(giving.id)}>
          <Card.FullWidth>
            <Image
              alt={giving.name}
              height={320}
              objectFit="cover"
              preview={false}
              src={giving.coverPhoto?.url ?? images.default.givingCoverPhoto}
              width="100%"
            />
          </Card.FullWidth>
        </Link>
      </Col>
      <Col span={24}>
        <Link to={routes.giving.detail(giving.id)}>
          <Row>
            <Col span={24}>
              <Tag color="orange-dark" icon={<Icon icon="hand-heart-line" />}>
                {getTranslate(giving.type)}
              </Tag>
            </Col>
            <Col span={24}>
              <Text type="title" weight="bold">
                {giving.name}
              </Text>
            </Col>
            {isParticipantsVisible ? (
              <Col span={24}>
                <DataCardParticipants
                  participants={{
                    count: giving.giversCount,
                    label: (formattedMembersCount) =>
                      t('formattedDonorsCount', { count: giving.giversCount, formattedCount: formattedMembersCount }),
                  }}
                />
              </Col>
            ) : null}
          </Row>
        </Link>
      </Col>
    </Row>
  );
};

export default GivingContentObjectBody;
